import { SnackbarKey } from 'notistack';
import {
  Notification,
  NotificationsCloseSnackbarAction,
  NotificationsEnqueueSnackbarAction,
  NotificationsRemoveSnackbarAction,
} from 'types/notifications';

const notificationsActions = {
  enqueueSnackbar: (notification: Notification) => {
    return {
      type: 'Notifications.SnackbarEnqueued',
      payload: {
        notification: {
          ...notification,
          key:
            notification?.options?.key || ((new Date().getTime() + Math.random()) as SnackbarKey),
        },
      },
    } as NotificationsEnqueueSnackbarAction;
  },
  closeSnackbar: (key?: SnackbarKey) =>
    ({
      type: 'Notifications.SnackbarClosed',
      payload: {
        key,
        dismissAll: !key, // dismiss all if no key has been defined
      },
    } as NotificationsCloseSnackbarAction),
  removeSnackbar: (key: SnackbarKey) =>
    ({
      type: 'Notifications.SnackbarRemoved',
      payload: {
        key,
      },
    } as NotificationsRemoveSnackbarAction),
};

export default notificationsActions;
